import { StyledCell } from 'components/base/Table/Table.styles';
import { FILTER_SETS_CELLS } from '../FilterSetsTable.model';
import ActionsCell from './cells/ActionsCell';
import NameCell from './cells/NameCell';
import TargetCell from './cells/TargetCell';
import { SAVED_FILTER_SET_TYPES } from '@linearb/linjs-common';
import moment from 'moment';

const useRows = ({ Context, data, listHandlers } = {}) => {
  const rows = data.map(filterSet => {
    const isProject = filterSet?.type === SAVED_FILTER_SET_TYPES.PROJECT;
    const row = {
      filterSet,
      dueDateValue: moment(filterSet?.metadata?.due_date).valueOf(),
      [FILTER_SETS_CELLS.NAME_CELL]: (
        <NameCell name={filterSet.name} filterSet={filterSet} />
      ),
      [FILTER_SETS_CELLS.VIEW_CELL]: (
        <StyledCell>{filterSet.visibility}</StyledCell>
      ),
      [FILTER_SETS_CELLS.OWNER_CELL]: (
        <StyledCell>{filterSet?.owner_name}</StyledCell>
      ),
      [FILTER_SETS_CELLS.ACTIONS_CELL]: (
        <ActionsCell
          Context={Context}
          filterSet={filterSet}
          listHandlers={listHandlers}
        />
      )
    };
    if (isProject) {
      row[FILTER_SETS_CELLS.TAEGET_CELL] = (
        <TargetCell target={filterSet?.metadata?.due_date} />
      );
    }
    return row;
  });

  return rows;
};

export default useRows;
